import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
const propTypes = {
  /**
   * Additional classes to apply to the input
   */
  className: PropTypes.string,
  /**
   * Error message to display. If provided, the message will be displayed below the input.
   */
  errorMessage: PropTypes.string,
  /**
   * The id of the input
   */
  id: PropTypes.string.isRequired,
  /**
   * The label for the input
   */
  label: PropTypes.string,
  /**
   * Callback function to handle the input's onChange event
   */
  onChange: PropTypes.func.isRequired,
  /**
   * The id of the row the input is in
   */
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * The status of the input
   */
  status: PropTypes.oneOf(['warning', 'disabled', 'error']),
  /**
   * The type of input
   */
  type: PropTypes.string,
  /**
   * The value of the input
   */
  value: PropTypes.node.isRequired
};
function InputCell(_ref) {
  let {
    className,
    errorMessage,
    id,
    label,
    onChange,
    rowId,
    status,
    type = 'text',
    value
  } = _ref;
  const formGroupClassNames = cx('asc-form-group', {
    'asc-form-input--warning': status === 'warning',
    'asc-form-input--error': status === 'error',
    'is-disabled': status === 'disabled'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "asc-table-component-editable-cell"
  }, /*#__PURE__*/React.createElement("div", {
    className: formGroupClassNames
  }, /*#__PURE__*/React.createElement("input", {
    value: value,
    onChange: onChange,
    id: id,
    name: id,
    className: className,
    type: type,
    "aria-describedby": status === 'warning' ? `row-${rowId}-inline-alert-message` : null
  }), label && /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "asc-acc-hidden"
  }, label), errorMessage && /*#__PURE__*/React.createElement("span", {
    className: "asc-form-help"
  }, errorMessage)));
}
InputCell.propTypes = propTypes;
export default InputCell;